import { render } from "./UserFollowButton.vue?vue&type=template&id=bee921d6"
import script from "./UserFollowButton.vue?vue&type=script&lang=js"
export * from "./UserFollowButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__